import axios from "axios";
import { ContentItem, PostItem } from "hc-entities";
import { environment } from "../../environment";
import { isExternalLinkHasVideoPlatform } from "../../helpers/helpers";

class PostItemService {
  private async castToPostObj(res: any): Promise<PostItem> {

    let post: PostItem | undefined;

    if (res && res.data && res.data[0]) {
      let _file,
        _thumbnail,
        r = res.data[0];
      if (r.content[0]?.media[0]?.azureLink) {
        _file = r.content[0]?.media[0]?.azureLink;
      }

      _thumbnail = r.thumbnail;

      if (_thumbnail) {
        r.content[0].thumbnail = _thumbnail;
      }
      if (_file) {
        r.content[0].media[0].file = _file;
      }

      if (
        (r.content[0]?.type === "external_link" ||
          r.content[0]?.type === "sefaria_link") &&
        r.content[0]?.media[0]?.link &&
        !isExternalLinkHasVideoPlatform(r.content[0]?.media[0]?.link)
          .hasPlatform
      ) {

        const og: any = await this.getOgData(r.content[0]?.media[0]?.link);
        if (og && og.data) {
          const d = og.data;
          if (d.title && !r.content[0].title) {
            r.content[0].title = d.title;
          }
          if (d.image) {
            r.content[0].thumbnail = d.image;
          }
        }
      }
      post = new PostItem({
        ...r,
        postSettings: r.postSettings,
        sessionContentItem: r.sessionContentItem ? r.sessionContentItem[0] : null,
        eventContentItem: r.eventContentItem ? r.eventContentItem[0] : null,
        communities: r.selectedCommunities,
        created: r.created ? new Date(parseInt(r.created)) : new Date(),
        content: new ContentItem({
          ...r.content[0],
          created: r.content[0]
            ? new Date(parseInt(r.content[0].created))
            : new Date(),
        }),
        tags: r.tags,
      });
      return post;
    } else {
      throw new Error("could not retrieve post");
    }
  }

  private async castToPostObjArray(res: any): Promise<PostItem[]> {
    let posts: PostItem[] = [];
    if (res?.data?.length > 0)
      res.data.map((item: any) => {
        if (item.entries) {
          item.entries.forEach( (r: any, i: number)=> {
            if (i < 1) {
              posts.push(
                new PostItem({
                  ...r,
                  sameContentItemPostEntries: item.entries,
                  sessionContentItem: r.sessionContentItem ? r.sessionContentItem[0] : null,
                  eventContentItem: r.eventContentItem ? r.eventContentItem[0] : null,
                  postSettings: r.postSettings,
                  communities: r.selectedCommunities,
                  created: new Date(parseInt(r.created)),
                  content: new ContentItem({
                    ...r.content[0],
                    created: r.content[0]
                      ? new Date(parseInt(r.content[0].created))
                      : new Date(),
                  }),
                  tags: r.tags,
                })
              );
            }

          })
        } else {
          posts.push(
            new PostItem({
              ...item,
              sessionContentItem: item.sessionContentItem ? item.sessionContentItem[0] : null,
              eventContentItem: item.eventContentItem ? item.eventContentItem[0] : null,
              postSettings: item.postSettings,
              communities: item.selectedCommunities,
              created: new Date(parseInt(item.created)),
              content: new ContentItem({
                ...item.content[0],
                created: item.content[0]
                  ? new Date(parseInt(item.content[0].created))
                  : new Date(),
              }),
              tags: item.tags,
            })
          );
        }

        return item;
      });

    posts = await Promise.all(
      posts.map(async (p) => {
        if (
          (p?.content?.type === "external_link" ||
            p?.content?.type === "sefaria_link") &&
          (p.content?.media[0] as any)?.link
        ) {
          try {
            const og: any = await this.getOgData(
              (p.content?.media[0] as any)?.link
            );
            if (og && og.data) {
              const d = og.data;
              if (d.title && !p.content.title) {
                p.content.title = d.title;
              }
              if (d.image) {
                p.content.thumbnail = d.image;
              }
            }
          }
          catch (err) {}
        }
        return p;
      })
    );
    return posts;
  }

  async getOgData(url: string) {
    try {
      //THIS KEY WILL BE HIDDEN IN FUTURE MAYBE IN ENV?
      const path = `https://api.linkpreview.net/?key=${environment.key}&q=${url}`;
      const ogData = await axios.get(path);
      return ogData;
    } catch (err) {
      throw err;
    }
  }

  async getMediaWP(mediaID: number) {
    try {
      const path = `${environment.wpImagesURL + mediaID}`;
      const data: any = await axios.get(path);
      const img = data?.media_details?.file;
      return img;
    } catch (err) {
      throw err;
    }
  }

  async searchPosts(uid: string, term: string) {
    try {
      const path = `${environment.contentUrl}posts/search/${uid}/${term}`;
      const res: any = await axios.get(path);
      return await this.castToPostObjArray(res);
    } catch (err) {
      throw err;
    }
  }

  async getAll(uid: string): Promise<PostItem[]> {
    try {
      const res = await axios.get(environment.contentUrl + "posts/user/" + uid);
      return await this.castToPostObjArray(res);
    } catch (err) {
      throw err;
    }
  }

  async getByCommunityId(cid: string): Promise<PostItem[]> {
    try {
      const res = await axios.get(
        environment.contentUrl + "posts/community/" + cid
      );
      return await this.castToPostObjArray(res);
    } catch (err) {
      throw err;
    }
  }

  async get(id: string, posts?: PostItem[]): Promise<PostItem> {
    try {
      const path = environment.contentUrl + "posts/list/" + id;
      const res: any = await axios.get(path);
      return await this.castToPostObj(res);
    } catch (err) {
      throw err;
    }
  }
}

export default new PostItemService() as PostItemService;
